import { render, staticRenderFns } from "./BSModal.vue?vue&type=template&id=7aa7acaf&"
import script from "./BSModal.vue?vue&type=script&lang=js&"
export * from "./BSModal.vue?vue&type=script&lang=js&"
import style0 from "./BSModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports